import { Box as MuiBox, styled } from '@mui/material';

export const List = styled('ul')({
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  '& li': {
    padding: 0,
    listStyle: 'none',
  },
  '& li:first-child button': {
    border: 'var(--pagination-btn-border)',
    display: 'flex',
    width: '36px',
    height: '36px',
    padding: '7px 8px',
    borderRadius: '5px',
    color: 'var(--pagination-btn-color)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& li:last-child button': {
    border: 'var(--pagination-btn-border)',
    display: 'flex',
    width: '36px',
    height: '36px',
    padding: '7px 8px',
    borderRadius: '5px',
    color: 'var(--pagination-btn-color)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& li:first-child button:disabled': {
    border: 'var(--pagination-btn-border-disabled)',
    display: 'flex',
    width: '36px',
    height: '36px',
    padding: '7px 8px',
    borderRadius: '5px',
    color: 'var(--pagination-btn-color-disabled)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& li:last-child button:disabled': {
    border: 'var(--pagination-btn-border-disabled)',
    color: 'var(--pagination-btn-color-disabled)',
    cursor: 'auto',
    width: '36px',
    height: '36px',
    padding: '7px 8px',
    borderRadius: '5px',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const PaginationButton = styled('button')({
  color: '#334155',
  border: 'none',
  cursor: 'pointer',
  background: 'none',
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '1rem',
  lineHeight: 0,
  letterSpacing: '0.5px',
  textAlign: 'center',
  verticalAlign: 'middle',
  minWidth: '36px',
  height: '36px',
  padding: '0 6px',
  borderRadius: '999px',
  transition: 'background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    color: '#1e3a8a',
    backgroundColor: 'rgba(37, 99, 235, 0.1)',
  },
  '&:focus-visible': {
    outline: '3px solid #93c5fd',
    outlineOffset: '2px',
  },
  '&[aria-current="true"]': {
    color: '#ffffff !important',
    fontWeight: 800,
    backgroundColor: '#1d4ed8',
    boxShadow: '0 0 0 1px rgba(29, 78, 216, 0.18)',
  },
  '&:disabled': {
    color: '#475569',
    cursor: 'default',
    backgroundColor: 'transparent',
  },
});

export const ContainerPagination = styled(MuiBox)({
  marginTop: '24px',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
});
